exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5de8c645]:export{navy:#001d38;turquoiseBlue:#00adbc;white:#fff;black:#000;error:#b71c1c;cancel:#f75b4a;success:#7ed321}.img-container[data-v-5de8c645]{max-height:170px;max-width:210px}.img-container[data-v-5de8c645],.img-container img[data-v-5de8c645]{border-radius:5px}@media screen and (max-width:768px){.img-container[data-v-5de8c645]{max-width:none;max-height:none}.img-container img[data-v-5de8c645]{width:100%}}.title-card[data-v-5de8c645]{font-size:18px}", ""]);

// exports
